<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
      class="ai-coding-dialog"
    >
      <div class="box-chat">
        <div v-for="item in list" :key="item.id" class="item" :class="{ 'item-my': item.isMy }">
          <img v-if="item.isMy" class="avatar" src="@/assets/img/user-msg-ai.png">
          <img v-else class="avatar" src="@/assets/img/bot-msg-ai.png">
          <div class="dialog">
            <div v-if="!item.editableTable" v-html="renderMarkdown(item.content)" class="markdown-body"></div>
            <div v-if="item.editableTable" class="table-edit-form">
              <h4 class="form-title">编辑表结构</h4>
              <div class="form-row">
                <div class="form-field">
                  <label>表名：</label>
                  <el-input v-model="item.editableTable.tableName" size="small" />
                </div>
                <div class="form-field">
                  <label>表注释：</label>
                  <el-input v-model="item.editableTable.tableComment" size="small" />
                </div>
              </div>
              <div class="column-header">
                <span class="col-name">列名称</span>
                <span class="col-type">列类型</span>
                <span class="col-comment">列注释</span>
                <span class="col-default">默认值</span>
                <span class="col-action">操作</span>
              </div>
              <div v-for="(col, idx) in item.editableTable.columns" :key="idx" class="column-item">
                <div class="column-row">
                  <el-input v-model="col.name" placeholder="列名称" size="small" class="col-name" />
                  <el-select v-model="col.type" placeholder="列类型" size="small" class="col-type">
                    <el-option v-for="t in typeOptions" :key="t.value" :label="t.label" :value="t.value" />
                  </el-select>
                  <el-input v-model="col.comment" placeholder="列注释" size="small" class="col-comment" />
                  <el-input v-model="col.defaultValue" placeholder="默认值" size="small" class="col-default" />
                  <el-button type="danger" icon="el-icon-delete" size="mini" circle class="col-action-btn" @click="removeColumn(item, idx)" />
                </div>
                <div v-if="col.type === 8 || col.type === 9" class="pointer-row">
                  <span class="pointer-label">关联表名（className）：</span>
                  <el-input v-model="col.className" placeholder="如 _User" size="small" style="width: 200px" />
                </div>
              </div>
              <div class="form-footer">
                <el-button size="small" icon="el-icon-plus" @click="addColumn(item)">添加列</el-button>
                <el-button size="small" type="primary" @click="applyEditedTable(item)">保存并创建表</el-button>
              </div>
            </div>
            <div v-if="!item.isMy && item.showExamples" class="example-list">
              <div v-for="(category, index) in examples" :key="index" class="example-category">
                <h4>{{ category.title }}</h4>
                <div class="example-items">
                  <div v-for="(example, i) in category.items" 
                       :key="i" 
                       class="example-item"
                       @click="sendExample(example.query)">
                    {{ example.text }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!item.isMy && item.content !== 'loading...' && item.content.includes('```')" class="code-actions">
              <el-button size="mini" type="text" @click="copyCode(item.content)">复制代码</el-button>
              <el-button v-if="mode === 'cloudFunction'" size="mini" type="text" @click="applyCode(item.content)">应用代码</el-button>
              <el-button v-if="mode === 'createTable'" size="mini" type="text" @click="editTableSchema(item.content)">编辑表</el-button>
              <el-button v-if="mode === 'createTable'" size="mini" type="primary" @click="applyCreateTable(item.content)">创建表</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="row-send">
        <div class="btn-clean" @click="cleanList">
          <img src="@/assets/images/clean.png">
          <span>新主题</span>
        </div>
          <el-input
          v-model="msg"
          :placeholder="mode === 'createTable' ? '请描述你想要创建的数据表...' : '请描述你的编程需求...'"
          size="normal"
          @keyup.enter.native="onSubmit"
        >
          <div slot="suffix" class="btn-send" @click="onSubmit">
            <i class="el-input__icon el-icon-s-promotion" />
          </div>
        </el-input>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import showdown from 'showdown'
import Bmob from 'hydrogen-js-sdk'
import { getUserInfo, setLeftAiCount, getLeftAiCount } from '@/api/user'
import { getCloudFunctionPrompt, getCreateTablePrompt } from './ai-coding/prompts'
import { cloudFunctionExamples, createTableExamples } from './ai-coding/examples'

export default {
  name: 'AiCoding',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    secretKey: {
      type: String,
      required: true
    },
    securityCode: {
      type: String,
      required: true
    },
    cloudName: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'cloudFunction',
      validator: val => ['cloudFunction', 'createTable'].includes(val)
    }
  },
  data() {
    return {
      dialogVisible: false,
      ChatAi: null,
      list: [{
        isMy: false,
        content: '你好，我是 AI 编程助手，请说明您的具体需求。',
        id: 'welcome',
        showExamples: true
      }],
      msg: '',
      lastId: '',
      userId: '',
      leftCount: 10,
      pingTimer: null,
      converter: new showdown.Converter({
        tables: true,
        simplifiedAutoLink: true,
        strikethrough: true,
        tasklists: true,
        ghCodeBlocks: true
      }),
      cloudFunctionExamples,
      createTableExamples,
      typeOptions: [
        { value: 0, label: 'String (文本)' },
        { value: 1, label: 'Number (数值)' },
        { value: 2, label: 'Boolean (布尔)' },
        { value: 3, label: 'Date (日期)' },
        { value: 4, label: 'File (文件)' },
        { value: 5, label: 'Geopoint (地理位置)' },
        { value: 6, label: 'Array (数组)' },
        { value: 7, label: 'Object (对象)' },
        { value: 8, label: 'Pointer (关联)' },
        { value: 9, label: 'Relation (多对多)' }
      ]
    }
  },
  computed: {
    dialogTitle() {
      return this.mode === 'createTable' ? 'AI 创建表' : 'AI 编程助手'
    },
    examples() {
      return this.mode === 'createTable' ? this.createTableExamples : this.cloudFunctionExamples
    },
    welcomeMessage() {
      if (this.mode === 'createTable') {
        return '你好，我是 AI 建表助手，请描述你想要创建的数据表，我会帮你设计表结构并一键创建。'
      }
      return `你好,我是 AI 编程助手,请说明您的具体需求，我将为云函数"${this.cloudName || '未命名'}"生成完整可用的代码。`
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        console.log('watch visible - cloudName:', this.cloudName)
        // 先检查本地缓存
        const cached = this.loadChatsFromLocal()
        if (!cached) {
          // 如果没有缓存，确保显示欢迎消息
          this.list = [{
            isMy: false,
            content: this.welcomeMessage,
            id: 'welcome',
            showExamples: true
          }]
        }
        this.initData()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
      if (!val) {
        if (this.ChatAi) {
          this.ChatAi.close()
          this.ChatAi = null
        }
      }
    },
    cloudName: {
      immediate: true,
      handler(val) {
        console.log('watch cloudName:', val)
        if (val) {
          const cached = this.loadChatsFromLocal()
          if (!cached) {
            this.list = [{
              isMy: false,
              content: this.welcomeMessage,
              id: 'welcome',
              showExamples: true
            }]
          }
        }
      }
    },
    list: {
      deep: true,
      handler() {
        this.saveChatsToLocal()
      }
    }
  },
  mounted() {
    const info = getUserInfo(true)
    this.userId = info ? (info.id + '') : '_tourist'
    this.leftCount = getLeftAiCount(this.userId)
    console.log('mounted - cloudName:', this.cloudName)
  },
  methods: {
    renderMarkdown(content) {
      if (!content) return ''
      try {
        return this.converter.makeHtml(content)
      } catch (error) {
        console.error('Markdown rendering error:', error)
        return content
      }
    },
    initData() {
      if (!this.secretKey || !this.securityCode) {
        this.$message.error('配置信息不完整，请稍后重试')
        this.dialogVisible = false
        return
      }

      try {
        console.log('secretKey', this.secretKey)
        console.log('securityCode', this.securityCode)
        Bmob.initialize(this.secretKey, this.securityCode)
        
        this.ChatAi = Bmob.ChatAI()

        let msg = ''
        this.ChatAi.onMessage((res) => {
          if (res === 'done') {
            this.setMsg(this.lastId, msg)
            if (msg) {
              this.lastId = ''
              msg = ''
            }
          } else {
            msg = msg + res
            this.setMsg(this.lastId, msg)
          }
        })

        this.ChatAi.onClose(() => {
          console.log('连接被关闭')
          if (this.dialogVisible) {
            this.ChatAi.connect()
          }
        })

        this.startPingTimer()

      } catch (err) {
        console.error('初始化 AI 失败:', err)
        this.$message.error('初始化 AI 失败，请稍后重试')
        this.dialogVisible = false
      }
    },
    handleClose(done) {
      this.stopPingTimer()
      if (this.ChatAi) {
        this.ChatAi.close()
        this.ChatAi = null
      }
      done()
    },
    cleanList() {
      this.list = [{
        isMy: false,
        content: this.welcomeMessage,
        id: 'welcome',
        showExamples: true
      }]
      const cacheKey = this.getCacheKey()
      if (cacheKey) {
        localStorage.removeItem(cacheKey)
      }
    },
    onSubmit() {
      if (this.leftCount <= 0) {
        this.$message.warning('您今日额度已用完，赶紧去购买额度试用吧！')
        return
      }
      if (this.userId && this.msg && !this.lastId) {
        const msg = this.msg
        this.list.push({
          isMy: true,
          content: msg
        })
        const id = new Date().getTime()
        this.list.push({
          isMy: false,
          content: 'loading...',
          id
        })
        this.msg = ''
        // 构建历史消息
        const messages = []
        // 跳过第一条欢迎消息
        for(let i = 1; i < this.list.length - 1; i++) {
          const item = this.list[i]
          if(item.content !== 'loading...') {
            messages.push({
              content: item.content,
              role: item.isMy ? 'user' : 'assistant'
            })
          }
        }
        // 添加当前消息
        if (this.mode === 'createTable') {
          messages.push({
            'model': 'gpt-4o-mini',
            content: msg,
            role: 'user'
          })
        } else {
          messages.push({
            'model': 'gpt-4o-mini',
            content: `请帮我为云函数"${this.cloudName}"生成以下代码: ${msg}`,
            role: 'user'
          })
        }
        const data = {
          messages,
          session: this.userId
        }

        let prompt = ''
        if (this.mode === 'createTable') {
          prompt = getCreateTablePrompt()
        } else {
          prompt = getCloudFunctionPrompt(this.secretKey, this.cloudName)
        }

        this.ChatAi.setPrompt(prompt)
        try {
          this.ChatAi.send(JSON.stringify(data))
          setLeftAiCount(this.userId, --this.leftCount)
          this.lastId = id
        } catch (err) {
          console.error(err)
        }
        this.scrollToBottom()
      }
    },
    setMsg(id, msg) {
      if (!msg) return
      const i = this.list.findIndex(e => e.id === id)
      if (i > -1) {
        this.list[i].content = msg
      }
      this.scrollToBottom()
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const chatBox = document.querySelector('.box-chat')
        if (chatBox) {
          chatBox.scrollTop = chatBox.scrollHeight
        }
      })
    },
    copyCode(content) {
      const codeMatch = content.match(/```[\s\S]*?\n([\s\S]*?)```/)
      if (codeMatch && codeMatch[1]) {
        const code = codeMatch[1].trim()
        const input = document.createElement('textarea')
        input.value = code
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.$message.success('代码已复制到剪贴板')
      }
    },
    applyCode(content) {
      const codeMatch = content.match(/```[\s\S]*?\n([\s\S]*?)```/)
      if (codeMatch && codeMatch[1]) {
        const code = codeMatch[1].trim()
        this.$emit('apply-code', code)
        this.$message.success('代码已应用')
      }
    },
    applyCreateTable(content) {
      const codeMatch = content.match(/```(?:json)?\s*\n([\s\S]*?)```/)
      if (!codeMatch || !codeMatch[1]) {
        this.$message.error('未找到有效的表结构数据')
        return
      }
      try {
        const tableData = JSON.parse(codeMatch[1].trim())
        if (!tableData.tableName || !tableData.columns || !tableData.columns.length) {
          this.$message.error('表结构数据不完整，缺少表名或列定义')
          return
        }
        this.$emit('create-table', tableData)
      } catch (e) {
        this.$message.error('表结构数据解析失败，请让 AI 重新生成')
      }
    },
    editTableSchema(content) {
      const codeMatch = content.match(/```(?:json)?\s*\n([\s\S]*?)```/)
      if (!codeMatch || !codeMatch[1]) {
        this.$message.error('未找到有效的表结构数据')
        return
      }
      try {
        const tableData = JSON.parse(codeMatch[1].trim())
        if (!tableData.tableName || !tableData.columns || !tableData.columns.length) {
          this.$message.error('表结构数据不完整')
          return
        }
        const columns = tableData.columns.map(col => ({
          name: col.name || '',
          type: col.type !== undefined ? col.type : 0,
          comment: col.comment || '',
          defaultValue: col.defaultValue !== undefined ? col.defaultValue : '',
          className: col.className || ''
        }))
        this.list.push({
          isMy: false,
          content: '',
          id: 'edit-' + Date.now(),
          editableTable: {
            tableName: tableData.tableName,
            tableComment: tableData.tableComment || '',
            columns
          }
        })
        this.scrollToBottom()
      } catch (e) {
        this.$message.error('表结构数据解析失败')
      }
    },
    addColumn(item) {
      item.editableTable.columns.push({
        name: '',
        type: 0,
        comment: '',
        defaultValue: '',
        className: ''
      })
      this.scrollToBottom()
    },
    removeColumn(item, idx) {
      if (item.editableTable.columns.length <= 1) {
        this.$message.warning('至少保留一个列')
        return
      }
      item.editableTable.columns.splice(idx, 1)
    },
    applyEditedTable(item) {
      const table = item.editableTable
      if (!table.tableName) {
        this.$message.error('请填写表名')
        return
      }
      if (!table.columns.length || table.columns.some(c => !c.name)) {
        this.$message.error('请确保所有列都填写了名称')
        return
      }
      const typeNameMap = { 0: 'String', 1: 'Number', 2: 'Boolean', 3: 'Date', 4: 'File', 5: 'Geopoint', 6: 'Array', 7: 'Object', 8: 'Pointer', 9: 'Relation' }
      const tableData = {
        tableName: table.tableName,
        tableComment: table.tableComment,
        columns: table.columns.map(col => {
          const result = {
            name: col.name,
            type: col.type,
            typeName: typeNameMap[col.type] || 'String',
            comment: col.comment,
            defaultValue: col.defaultValue
          }
          if (col.type === 8 || col.type === 9) {
            result.className = col.className
          }
          return result
        })
      }
      this.$emit('create-table', tableData)
    },
    startPingTimer() {
      this.stopPingTimer()
      this.pingTimer = setInterval(() => {
        if (this.ChatAi) {
          try {
            this.ChatAi.send('ping')
          } catch (err) {
            console.error('Ping failed:', err)
          }
        }
      }, 10000)
    },
    stopPingTimer() {
      if (this.pingTimer) {
        clearInterval(this.pingTimer)
        this.pingTimer = null
      }
    },
    sendExample(example) {
      this.msg = example
    },
    getCacheKey() {
      if (this.mode === 'createTable') return 'ai_chat_createTable'
      if (this.cloudName) return `ai_chat_${this.cloudName}`
      return ''
    },
    saveChatsToLocal() {
      const key = this.getCacheKey()
      if (!key) return
      localStorage.setItem(key, JSON.stringify(this.list))
    },
    loadChatsFromLocal() {
      const key = this.getCacheKey()
      if (!key) return false
      const cached = localStorage.getItem(key)
      if (cached) {
        this.list = JSON.parse(cached)
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
.ai-coding-dialog {
  display: flex;
  flex-direction: column;
}

.box-chat {
  height: 60vh;
  overflow-y: auto;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 4px;
}

.item {
  display: flex;
  margin-bottom: 20px;
}

.item-my {
  flex-direction: row-reverse;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 0 10px;
}

.dialog {
  max-width: 80%;
  padding: 10px 15px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.item-my .dialog {
  background: #e3f2fd;
}

.row-send {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.btn-clean {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 15px;
  padding: 4px 20px;
  padding-left: 10px;
  background-color: #f5f5f5;
  border-radius: 20px;
  transition: all 0.3s ease;
  white-space: nowrap;
  font-size: 14px;
  line-height: 1.5;
}

.btn-clean:hover {
  background-color: #e8e8e8;
}

.btn-clean img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  filter: brightness(0.4);
}

.btn-send {
  cursor: pointer;
  padding: 0 10px;
}

.btn-send i {
  font-size: 20px;
  color: #409EFF;
}

.code-actions {
  margin-top: 10px;
  text-align: right;
}

.dialog a {
  color: #409EFF;
  text-decoration: none;
  display: block;
  margin: 8px 0;
  line-height: 1.5;
}

.dialog a:hover {
  text-decoration: underline;
}

.example-list {
  margin-top: 15px;
  border-top: 1px solid #eee;
  padding-top: 15px;
}

.example-category {
  margin-bottom: 15px;
}

.example-category h4 {
  margin: 0 0 10px 0;
  color: #606266;
  font-size: 14px;
}

.example-items {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.example-item {
  padding: 8px 12px;
  background: #f0f9ff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  color: #409EFF;
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.example-item:hover {
  background: #ecf5ff;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.table-edit-form {
  padding: 5px 0;
}

.table-edit-form .form-title {
  margin: 0 0 12px 0;
  font-size: 15px;
  color: #303133;
}

.table-edit-form .form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 14px;
}

.table-edit-form .form-field {
  display: flex;
  align-items: center;
  gap: 6px;
}

.table-edit-form .form-field label {
  white-space: nowrap;
  font-size: 13px;
  color: #606266;
}

.column-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 8px;
  font-size: 13px;
  color: #909399;
  font-weight: 500;
}

.column-header .col-name { flex: 3; }
.column-header .col-type { flex: 3; }
.column-header .col-comment { flex: 3; }
.column-header .col-default { flex: 2; }
.column-header .col-action { width: 32px; text-align: center; flex-shrink: 0; }

.column-item {
  margin-bottom: 6px;
}

.column-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.column-row .col-name { flex: 3; }
.column-row .col-type { flex: 3; }
.column-row .col-comment { flex: 3; }
.column-row .col-default { flex: 2; }
.column-row .col-action-btn { flex-shrink: 0; }

.pointer-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 0 4px 4px;
}

.pointer-row .pointer-label {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
}

.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #ebeef5;
}

.markdown-body {
  font-size: 14px;
  line-height: 1.6;
  word-wrap: break-word;
}

.markdown-body pre {
  background-color: #f6f8fa;
  border-radius: 6px;
  padding: 16px;
  overflow: auto;
  font-size: 14px;
  line-height: 1.45;
  margin: 8px 0;
}

.markdown-body code {
  font-family: Monaco, Consolas, "Courier New", monospace;
  font-size: 14px;
  padding: 0.2em 0.4em;
  margin: 0;
  border-radius: 3px;
  background-color: rgba(27,31,35,0.05);
}

.markdown-body pre code {
  background-color: transparent;
  padding: 0;
}

.markdown-body p {
  margin: 8px 0;
}

.markdown-body ul,
.markdown-body ol {
  padding-left: 2em;
  margin: 8px 0;
}

.markdown-body table {
  border-spacing: 0;
  border-collapse: collapse;
  margin: 8px 0;
  width: 100%;
}

.markdown-body table th,
.markdown-body table td {
  padding: 6px 13px;
  border: 1px solid #dfe2e5;
}

.markdown-body table th {
  background-color: #f6f8fa;
  font-weight: 600;
}

.markdown-body h1,
.markdown-body h2,
.markdown-body h3,
.markdown-body h4 {
  margin-top: 24px;
  margin-bottom: 16px;
  font-weight: 600;
  line-height: 1.25;
}
</style>
